import React from 'react';
import './MartianHunt.css';
import AndroidMartian from '../../../assets/img/martian/android-mockup.webp';
import GooglePlayBadge from '../../../assets/img/martian/google-play-badge.svg';

const MartianHunt = () => {
    return (
        <>
            <section>
                <h1 className="martian-title">Martian Hunt</h1>
                <div className="martian-information">
                    <div className="description">
                        <p>Caza a todos los marcianos que puedas en un minuto, ¡no permitas que tomen el planeta!</p>
                        <p>¡Descárgalo ahora!</p>

                        <a href="https://play.google.com/store/apps/details?id=com.skyservants.martianhunt" target="_blank" rel="noreferrer"><img src={GooglePlayBadge} alt="google-play-badge" /></a>
                    </div>
                    <div className="mobile-img">
                        <img src={AndroidMartian} alt=""></img>
                    </div>
                </div>
            </section>
        </>
    );
};

export default MartianHunt;